import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import DownloadOption from "../DownloadOption";

export default class PrintModal extends Component {

    constructor (props) {

        super(props);
        this.state = {

        };

    }

    print () {
        const maindiv = document.getElementById(this.props.mainDiv);
        const section = document.createElement("div");
        section.id = "print-section";
        section.innerHTML = "";
        section.style.width = "100%";
        section.style.marginLeft = "25px";
        section.style.marginRight = "25px";

        document.body.appendChild(section);

        const printContent = document.getElementById("print-content"),
            clonedPrintContent = printContent.cloneNode(true),

            nodesToHide = clonedPrintContent.querySelectorAll(".print-hide");
        nodesToHide.forEach((node) => {

            node.remove();

        });

        section.appendChild(clonedPrintContent);
        maindiv.style.display = "none";

        setTimeout(
            () => {

                window.print();
                maindiv.style.display = "";
                document.getElementById("print-section").remove();

            },
            500
        );

    }

    render () {
        
        return (
            <Modal
                onHide={this.props.onHide}
                show={this.props.show}
                size="lg"
            >
                <Modal.Header style={{"alignItems": "center", "display": "flex", "justifyContent": "space-between"}}>
                    <Modal.Title style={{"marginBottom": 0}}>
                        Print Preview
                    </Modal.Title>
                    <button
                        aria-label="Close"
                        onClick={this.props.onHide}
                        style={{
                            "background": "transparent",
                            "border": 0,
                            "cursor": "pointer",
                            "fontFamily": "Arial, sans-serif",
                            "fontSize": "1.75rem",
                            "fontWeight": 700,
                            "lineHeight": 1,
                            "marginLeft": "auto",
                            "padding": 0
                        }}
                        type="button"
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {this.props.dataLoaded
                        ? <>
                            <div className="print" style={{
                                "float": "right",
                                "cursor": "pointer"
                            }}>
                                {
                                    this.props.downloadData &&
                                    <DownloadOption
                                        id="downloadOption"
                                        fileName={this.props.downloadData.fileName}
                                        columns={this.props.downloadData.columns}
                                        ExcelData={this.props.downloadData.data}
                                        CSVData={this.props.downloadData.data}
                                        tooltip={this.props.downloadFileButton}
                                        action={this.props.downloadData.action}
                                    />
                                }
                                <i
                                    className="material-icons"
                                    onClick={() => this.print()}
                                    title="Print"
                                >
                                    print
                                </i>
                            </div>
                            <div id="print-content">
                                {this.props.content}
                            </div>
                          </>

                        : <Spinner
                            animation="grow"
                            role="status"
                        >
                            <span className="sr-only">
                                Loading...
                            </span>
                        </Spinner>}
                </Modal.Body>
            </Modal>
        );

    }

}
